import React from 'react'
// types
import { Field } from 'redux-form'
import { Validators } from 'utils/validators'
import { WrappedFieldProps } from 'redux-form/lib/Field'
import LocationPicker, { LocationPickerProps, Place } from 'components/FormElements/LocationPicker'

interface Props extends Omit<LocationPickerProps, 'placeholder' | 'value' | 'onChange' | 'defaultValue'> {
  validate?: Validators
  onChange?: (address: any) => void
}

const Component: React.FC<Props & WrappedFieldProps> = ({ meta: { touched, error }, input, onChange, ...props }) => {
  const handleChange = (value: Place) => {
    input.onChange(value)
    onChange?.(input.value)
  }

  const handleFocus = () => {
    input.onFocus(input.value)
  }

  const handleBlur = () => {
    input.onBlur(input.value)
  }

  const isError = touched && !!error

  return (
    <LocationPicker
      isError={isError}
      value={input.value}
      handleBlur={handleBlur}
      handleFocus={handleFocus}
      handleChange={handleChange}
      {...props}
    />
  )
}

const ReduxLocationPicker: React.FC<Props> = (props) => <Field {...props} component={Component} />

export default ReduxLocationPicker
